var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n  Contact\n  "),
      _c("p", [_vm._v("To do ...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }